<template>
  <div class="common-page-main main-page">
    <div class="field-box scroll-cotar">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Agent classification</span>
        </div>
        <div class="rfp">
          <el-button size="small" icon="plus" type="primary" @click="showAddPop()">Add</el-button>
        </div>
        <!-- <div class="mc-search-box hf rfp">
            <div class="ftp">
              <el-input size="small" class="mc-search-wrap" placeholder="Please enter the content" v-model="search.value">
                <el-select size="small" v-model="search.key" slot="prepend" placeholder="请选择">
                  <el-option label="券码" value="VNum"></el-option>
                  <el-option label="发放人姓名" value="VCustomerName"></el-option>
                  <el-option label="发放人手机号" value="VCustomerMobile"></el-option>
                  <el-option label="发放人车牌号" value="VCustomerCarNum"></el-option>
                </el-select>
                <el-button slot="append" icon="search" @click="handleSearch"></el-button>
              </el-input>
            </div>
            <el-button size="small" class="search-btn ftp" @click="handleResetSearch">重置</el-button>
          </div> -->
      </div>
      <div class="table-wrap">
        <el-table :data="table.data" v-loading="table.isLoading" element-loading-text="Loading" style="width: 100%">
          <el-table-column label="Name" prop="CtName"></el-table-column>
          <el-table-column label="Sort" prop="Sort"></el-table-column>
          <el-table-column label="Operate" width="200">
            <template slot-scope="scope">
              <el-button size="small" @click="showUpdatePop(scope.$index, scope.row)">Edit</el-button>
              <el-button size="small" @click="handleDel(scope.$index, scope.row)">Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <el-pagination @current-change="handleTableCurrentChange" :current-page="table.currentPage" :page-size="table.pageSize" layout="total, prev, pager, next" :total="table.pageTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 详情弹出层 -->
    <el-dialog title="Details" :visible.sync="page.popShow" size="tine">
      <ProductMemberTypeForm @addSuccess="handleAdd" @updateSuccess="handleUpdate" ref="popForm"></ProductMemberTypeForm>
    </el-dialog>
  </div>
</template>

<script>
// import $ from 'jquery'
import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
import ProductMemberTypeForm from '@/components/product/ProductMemberTypeForm'

// 表格相关操作
let table = {
  methods: {
    getTableData: tools.commonTableDateFetch({
      url: '/Ajax/GetCustomTypeListInAdmin',
      data() {
        return {
          OrderName: 'SORT ASC'
        }
      },
      success(response) {
        let result = response.data
        this.table.data = result
      }
    }),
    refreshTableData() {
      this.getTableData(this.table.currentPage)
    }
  }
}

// 请求相关操作
let page = {
  methods: {
    // 删除操作
    delDataAjax(CtCode) {
      tools.commonAjax.call(this, true, '/Ajax/DelCustomTypeInAdmin', {
        CtCode
      }).then(() => {
        this.$message.success('Deleted successfully!')
        // 重新获取列表数据
        this.refreshTableData()
      })
    }
  }
}

export default {
  name: 'ProductMemberTypeManagement',
  mixins: [table, page, mixin.filter],
  components: {
    ProductMemberTypeForm
  },
  created() {
    this.getTableData()
  },
  data() {
    return {
      search: {
        key: '',
        value: ''
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    }
  },
  methods: {
    // 搜索事件
    handleSearch() {
      if (this.search.value) {
        this.table.ajaxData = {}
        this.table.ajaxData[this.search.key] = this.search.value
        this.refreshTableData()
      } else {
        this.$message.error('Please enter the search content')
      }
    },
    // 重置搜索
    handleResetSearch() {
      this.table.ajaxData = {}
      this.search.value = ''
      this.refreshTableData()
    },
    // 页码点击事件
    handleTableCurrentChange(val) {
      this.getTableData(val)
    },
    // 显示新增弹出层
    showAddPop() {
      this.page.popShow = true
      this.$nextTick(function () {
        this.$refs.popForm.resetValue()
      })
    },
    // 显示修改弹出层
    showUpdatePop(idx, item) {
      this.page.popShow = true
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item)
      })
    },
    // 添加操作
    handleAdd() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 修改操作
    handleUpdate() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 删除操作
    handleDel(idx, item) {
      this.$confirm('This operation will permanently delete the record, whether to continue?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.delDataAjax(item.CtCode)
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// ProductMemberTypeManagement.vue?7e84dbcc